import { useUserInput } from '../useUserInput';

export const useHasIntegratedSolution = (): boolean => {
	const { hasIntegratedSolution } = useUserInput();

	return hasIntegratedSolution || false;
};
